import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

const useAddProduct = (name, price, discountedPrice, images) => {
  const usersCollectionRef = collection(db, "products");

  const createUser = async (name, price, discountedPrice, images) => {
    await addDoc(usersCollectionRef, {
      name: name,
      price: Number(price),
      discountedPrice: Number(discountedPrice),
      images: images,
    });
  };

  createUser(name, price, discountedPrice, images);
};

export default useAddProduct;
